import React from 'react';
import Header from '../components/Header';
import ProjectsGrid from '../components/ProjectsGrid';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ProjectsGrid />
      <Footer />
    </div>
  );
};

export default Home;